





























import router from "@/router/router";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import Vue from "vue";
import DeviceDescription from "@/views/Dashboard/Management/Device/DeviceDescription.vue";
import DeviceGraph from "@/views/Dashboard/Management/Device/DeviceGraph.vue";
import TabsTable from "@/components/Tabs/TabsTable.vue";
import { store } from "@/store/store";

export default Vue.extend({
  name: "DeviceTabs",
  components: { NavbarTitle, DeviceDescription, DeviceGraph, TabsTable },
  data() {
    return {
      tabs: ["Général", "Graphique"],
      currentTab: "Général"
    };
  },
  methods: {
    MoveToDevicePage(): void {
      router.go(-1);
    },
    OnTabClick(tab: string): void {
      this.currentTab = tab;
    }
  },
  computed: {
    deviceName() {
      return store.getters.DEVICE_BY_ID[this.$route.query.deviceId as string].material_name;
    }
  },
  watch: {}
});
